import Palette from '@opsbase/lib-palette';
import useAssetCountByType from '@opsbase/react-gql-hooks/asset/useAssetCountByType';
import useOrgDeleteAssetType from '@opsbase/react-gql-hooks/organisation/useOrgDeleteAssetType';
import i18n from '@opsbase/lib-i18n';
import ConfirmDialog from '@opsbase/web-dialogs/ConfirmDialog';
import useParams from '@opsbase/web-nav/useParams';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback } from 'react';
export function AssetTypeDeleteDialog() {
    const { type } = useParams();
    const { loading, data: count } = useAssetCountByType({ variables: { type } });
    const deleteAssetType = useOrgDeleteAssetType();
    const text = i18n.t('confirm-asset-type-delete', { count });
    const deleteText = i18n.t('delete');
    const cancelText = i18n.t('cancel');
    const handleAction = useCallback(async () => {
        return deleteAssetType({ type });
    }, [deleteAssetType, type]);
    return (React.createElement(ConfirmDialog, { loading: loading, onConfirm: handleAction, agreeText: deleteText, notAgreeText: cancelText, color: Palette.error },
        React.createElement(Text, null, text)));
}
export default AssetTypeDeleteDialog;
